/**
 * Places a line drawn down the timeline `left` pixels into its container by transform on its own layer, because WebKit leaves a line moved by `left` painted where it was.
 */
export function timelineLineStyle(left: number, top: number, height: number) {
  return {
    left: 0,
    top,
    height,
    transform: `translateX(${left}px)`,
    willChange: "transform",
  }
}

export function measureAudioTimeline(container: HTMLElement) {
  const tracks = Array.from(
    container.querySelectorAll<HTMLElement>("[data-audio-timeline-duration]"),
  ).flatMap((element) => {
    const rect = element.getBoundingClientRect()
    const duration = Number(element.dataset.audioTimelineDuration)
    const viewport = element.closest("[data-audio-timeline-viewport]")
    const clip = viewport?.getBoundingClientRect() ?? rect
    const top = Math.max(rect.top, clip.top)
    const bottom = Math.min(rect.bottom, clip.bottom)
    return rect.width > 0 &&
      bottom > top &&
      duration > 0 &&
      Number.isFinite(duration)
      ? [{ rect, top, bottom, duration }]
      : []
  })
  const top = Math.min(...tracks.map((track) => track.top))
  const bottom = Math.max(...tracks.map((track) => track.bottom))
  const containerRect = container.getBoundingClientRect()
  return {
    tracks,
    top,
    bottom,
    containerRect,
    clientLeft: container.clientLeft,
    clientTop: container.clientTop,
  }
}
